import { render } from "./InitialHoldWithPartnerModal.vue?vue&type=template&id=f006b448&ts=true&lang=pug"
import script from "./InitialHoldWithPartnerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitialHoldWithPartnerModal.vue?vue&type=script&lang=ts&setup=true"

import "./InitialHoldWithPartnerModal.vue?vue&type=style&index=0&id=f006b448&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__